<template>
  <v-card-text>
    <!-- Options -->
    <v-row mt-6 mb-4>
      <v-col cols="12" sm="6" md="4" lg="3" xl="2">
        <v-select
          v-model="criteria.aggregate_country"
          :items="countries"
          variant="outlined"
          item-title="text"
          label="Country"
          hide-details
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3" xl="2">
        <v-text-field
          v-model="criteria.aggregate_security_name"
          type="text"
          variant="outlined"
          placeholder=" "
          label="Security Name"
          hide-details
        />
      </v-col>
    </v-row>

    <!-- Table -->
    <v-data-table-server
      v-model:options="pagination"
      v-model:sort-by="pagination.sortBy"
      :headers="tableHeaders"
      :items="tableItems"
      :items-length="totalItems"
      :items-per-page-options="[10, 25, 50, 100]"
      :loading="loading"
      :no-data-text="no_data_text"
      must-sort
    >
      <template #item="{ item }">
        <tr>
          <td>
            <router-link
              v-if="item.stock_permalink"
              :to="'/short/short_position_issuer/' + item.stock_permalink"
            >
              {{ item.stock_name }}</router-link
            >
            <span v-else>{{ item.stock_name }}</span>
          </td>
          <td>{{ item.current_net_shorts }}</td>
          <td>{{ percent(item.net_shorts_change_week) }}</td>
          <td>{{ percent(item.net_shorts_change_month) }}</td>
          <td>{{ percent(item.net_shorts_change_year) }}</td>
          <td>{{ item.country }}</td>
        </tr>
      </template>
    </v-data-table-server>
  </v-card-text>
</template>

<script>
import { useUserStore, useAppStore, useWwStore } from '@/store'
// Modules
import { apiRoot } from '@/store/api'
import debounce from 'lodash/debounce'

// Mixins
import FormattersMixin from '@/mixins/formatters'

export default {
  components: {},
  mixins: [FormattersMixin],

  data() {
    return {
      loading: false,
      tableHeaders: [
        { title: 'Issuer', key: 'stock_name' },
        { title: 'Current', key: 'current_net_shorts' },
        { title: 'Change 1 Week Ago', key: 'net_shorts_change_week' },
        { title: 'Change 1 Month Ago', key: 'net_shorts_change_month' },
        { title: 'Change 1 Year Ago', key: 'net_shorts_change_year' },
        { title: 'Country', key: 'country' }
      ],
      totalItems: 0,
      tableItems: [],
      pagination: {
        sortBy: [{ key: 'current_net_shorts', order: 'desc' }],
        page: 1,
        itemsPerPage: 10
      },
      criteria: {
        aggregate_country: 'all',
        aggregate_security_name: ''
      },
      countries: [
        { value: 'all', text: 'All' },
        { value: 'austria', text: 'Austria' },
        { value: 'belgium', text: 'Belgium' },
        { value: 'denmark', text: 'Denmark' },
        { value: 'finland', text: 'Finland' },
        { value: 'france', text: 'France' },
        { value: 'germany', text: 'Germany' },
        { value: 'greece', text: 'Greece' },
        { value: 'hong kong', text: 'Hong Kong' },
        { value: 'iceland', text: 'Iceland' },
        { value: 'ireland', text: 'Ireland' },
        { value: 'italy', text: 'Italy' },
        { value: 'japan', text: 'Japan' },
        { value: 'netherlands', text: 'Netherlands' },
        { value: 'norway', text: 'Norway' },
        { value: 'poland', text: 'Poland' },
        { value: 'portugal', text: 'Portugal' },
        { value: 'spain', text: 'Spain' },
        { value: 'sweden', text: 'Sweden' }
      ],
      results: null
    }
  },

  computed: {
    params() {
      return {
        aggregate_country: this.criteria.aggregate_country,
        aggregate_security_name: this.criteria.aggregate_security_name,
        rows: this.pagination.itemsPerPage,
        page: this.pagination.page,
        sort: this.pagination.sortBy[0]?.key,
        order: this.pagination.sortBy[0]?.order || 'asc',
        ...this.filtersParamsObject
      }
    },
    isLoggedIn() {
      return useUserStore().isLoggedIn
    },
    no_data_text() {
      if (!this.isLoggedIn) {
        return 'You must be logged in to use this search.'
      } else if (this.loading) {
        return 'Loading...'
      } else if (this.results == 'Subscription required') {
        return 'Subscription required'
      } else {
        return 'No results found.'
      }
    }
  },

  watch: {
    params: {
      deep: true,
      handler() {
        this.updateData()
      }
    },
    isLoggedIn(val) {
      if (val) this.updateData()
    }
  },

  methods: {
    updateData: debounce(function () {
      if (!useUserStore().isLoggedIn) {
        this.tableItems = []
        this.totalItems = 0
        this.loading = false
        return
      }
      this.loading = true

      apiRoot
        .get('/short_position/aggregate_search_table?', { params: this.params })
        .then(response => {
          this.results = response.data
          if (response.data.rows) {
            this.tableItems = response.data.rows
            this.totalItems = response.data.records
          }
        })
        .catch(error => {
          useAppStore().showNotification({
            type: 'error',
            text: (error.response && error.response.data) || error.message
          })
        })
        .then(() => (this.loading = false))
    }, 750)
  }
}
</script>
